module.exports = __webpack_public_path__ + "static/media/beanCancel.6668e0a2.svg";